'use client'
import {
  Responsive_default
} from "./chunk-APMRHXVI.mjs";
import {
  Typography_default
} from "./chunk-TDL5JRE5.mjs";
import {
  Button_default
} from "./chunk-EGOGHW2A.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Popover/Popover.tsx
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { twMerge } from "tailwind-merge";

// src/Popover/Footer.tsx
import { useTranslation } from "@wbk/config";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var PopoverFooter = ({ customAction, action, cancel, close }) => {
  const { t } = useTranslation("ui_common");
  return /* @__PURE__ */ jsx("div", { className: "border-paper flex justify-between gap-4 border-t p-6 py-4", children: customAction ? customAction({ close }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: "flex grow justify-end gap-2 data-[cancel=true]:justify-between",
      "data-cancel": cancel !== false,
      children: [
        cancel !== false && /* @__PURE__ */ jsx(
          Button_default,
          __spreadProps(__spreadValues({
            type: "button",
            theme: "action",
            shape: "text"
          }, cancel), {
            onClick: () => {
              if (cancel == null ? void 0 : cancel.onClick) {
                return cancel.onClick({ close });
              }
              close();
            },
            children: /* @__PURE__ */ jsx(Typography_default, { children: (cancel == null ? void 0 : cancel.label) || t("ui_common:cancel") })
          })
        ),
        action !== false && /* @__PURE__ */ jsx(
          Button_default,
          __spreadProps(__spreadValues({
            type: "submit",
            theme: "action"
          }, action), {
            onClick: () => {
              if (action == null ? void 0 : action.onClick) {
                return action.onClick({ close });
              }
            },
            children: /* @__PURE__ */ jsx(Typography_default, { strong: true, children: (action == null ? void 0 : action.label) || t("ui_common:confirm") })
          })
        )
      ]
    }
  ) }) });
};
var Footer_default = PopoverFooter;

// src/Popover/Popover.tsx
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var Popover = (_a) => {
  var _b = _a, {
    content,
    defaultOpen,
    open,
    onOpenChange,
    modal,
    className,
    children,
    action = false,
    cancel = false,
    customAction,
    ref
  } = _b, props = __objRest(_b, [
    "content",
    "defaultOpen",
    "open",
    "onOpenChange",
    "modal",
    "className",
    "children",
    "action",
    "cancel",
    "customAction",
    "ref"
  ]);
  const hasCancal = cancel !== false;
  const hasAction = action !== false;
  const hasFooter = hasCancal || hasAction || !!customAction;
  return /* @__PURE__ */ jsxs2(
    PopoverPrimitive.Root,
    {
      defaultOpen,
      open,
      onOpenChange,
      modal,
      children: [
        /* @__PURE__ */ jsx2(PopoverPrimitive.Trigger, { asChild: true, children }),
        /* @__PURE__ */ jsx2(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsxs2(
          PopoverPrimitive.Content,
          __spreadProps(__spreadValues({
            ref,
            className: twMerge(
              "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
              "bg-input-popover border-input-border rounded-S z-50 max-h-[calc(var(--radix-popover-content-available-height)-20px)] w-[var(--radix-popover-trigger-width)] min-w-[var(--radix-popover-trigger-width)] overflow-hidden border",
              className
            )
          }, props), {
            children: [
              /* @__PURE__ */ jsx2(
                "div",
                {
                  "data-footer": hasFooter,
                  className: "mini-scrollbar max-h-[calc(var(--radix-popover-content-available-height)-20px)] w-full overflow-y-auto p-6 data-[footer=true]:max-h-[calc(var(--radix-popover-content-available-height)-100px)]",
                  children: content
                }
              ),
              hasFooter && /* @__PURE__ */ jsx2(Fragment2, { children: customAction ? /* @__PURE__ */ jsx2(
                Footer_default,
                {
                  customAction,
                  close: () => {
                    onOpenChange == null ? void 0 : onOpenChange(false);
                  }
                }
              ) : /* @__PURE__ */ jsx2(
                Footer_default,
                {
                  action,
                  cancel,
                  close: () => {
                    onOpenChange == null ? void 0 : onOpenChange(false);
                  }
                }
              ) })
            ]
          })
        ) })
      ]
    }
  );
};
var Popover_default = Popover;

// src/Popover/Responsive.tsx
import { Fragment as Fragment3, useState } from "react";
import * as PopoverPrimitive2 from "@radix-ui/react-popover";
import { twMerge as twMerge2 } from "tailwind-merge";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var ResponsivePopover = ({ render, body, popover, sheet }) => {
  const [isOpen, setIsOpen] = useState(false);
  const _a = popover || {}, { modal, className, action, cancel, customAction, ref } = _a, props = __objRest(_a, ["modal", "className", "action", "cancel", "customAction", "ref"]);
  const hasCancal = cancel !== false;
  const hasAction = action !== false;
  const hasFooter = hasCancal || hasAction || customAction;
  const open = () => {
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
  };
  return /* @__PURE__ */ jsxs3(Fragment3, { children: [
    /* @__PURE__ */ jsx3(
      Responsive_default,
      __spreadProps(__spreadValues({
        render: (props2) => /* @__PURE__ */ jsx3("div", { className: "flex md:hidden", children: render(props2) }),
        body,
        type: "sheet",
        actionsStyle: "fixed"
      }, sheet), {
        className: twMerge2("md:hidden", sheet == null ? void 0 : sheet.className)
      })
    ),
    /* @__PURE__ */ jsxs3(PopoverPrimitive2.Root, { open: isOpen, onOpenChange: (open2) => setIsOpen(open2), modal, children: [
      /* @__PURE__ */ jsx3(PopoverPrimitive2.Trigger, { asChild: true, children: /* @__PURE__ */ jsx3("div", { className: "hidden md:flex", children: render({ close, open, isOpen }) }) }),
      /* @__PURE__ */ jsx3(PopoverPrimitive2.Portal, { children: /* @__PURE__ */ jsxs3(
        PopoverPrimitive2.Content,
        __spreadProps(__spreadValues({
          ref
        }, props), {
          className: twMerge2(
            "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            "bg-input-popover border-input-border rounded-M z-50 hidden max-h-[calc(var(--radix-popover-content-available-height)-20px)] w-[var(--radix-popover-trigger-width)] min-w-[var(--radix-popover-trigger-width)] border md:block",
            className
          ),
          children: [
            /* @__PURE__ */ jsx3(
              "div",
              {
                "data-footer": hasFooter,
                className: "mini-scrollbar max-h-[calc(var(--radix-popover-content-available-height)-20px)] overflow-y-auto p-6 data-[footer=true]:max-h-[calc(var(--radix-popover-content-available-height)-100px)]",
                children: body({ close })
              }
            ),
            hasFooter && /* @__PURE__ */ jsx3(Footer_default, __spreadProps(__spreadValues({}, popover), { close }))
          ]
        })
      ) })
    ] })
  ] });
};
var Responsive_default2 = ResponsivePopover;

export {
  Popover_default,
  Responsive_default2 as Responsive_default
};
//# sourceMappingURL=chunk-D24CC4PG.mjs.map